import React, { useEffect, useState } from "react";
import SumsubWebSdk from "@sumsub/websdk-react";
import { getSumsubToken } from "../services/apiService";
import { useActiveAccount, useActiveWalletChain } from "thirdweb/react";

const SumsubVerification = () => {
    const add = useActiveAccount();
    const [address, setAddress] = useState("");
    const chain = useActiveWalletChain();

    useEffect(() => {
        if (add && add.address && chain) {
            setAddress(add.address);

        }
    }, [add, chain]);

    const [token, setToken] = useState("");
    const [tab, setTab] = useState('pending');
    const [, setShowRefreshButton] = useState(false);

    useEffect(() => {
        if (address) {

            getSumsubToken(address).then((res) => {
                if (res?.data?.token) {
                    setToken(res.data.token);
                }
            });
        }
    }, [address]);

    return (
        <div
            style={{
                width: "100%",
                background:
                    "linear-gradient(128.02deg, #FFFFFF 20.52%, #215C98 70.66%)",
                textAlign: "center",
                // padding: "20px",
            }}
        >
            {
                tab === "Completed" ?
                    <>
                        <h3>Your Kyc is Completed</h3>
                    </>
                    :
                    token ? (
                        <>
                            <SumsubWebSdk
                                accessToken={token}
                                expirationHandler={() => Promise.resolve(token)}
                                config={{
                                    lang: "en-EN",
                                    i18n: {
                                        document: {
                                            subTitles: {
                                                IDENTITY: "Upload a document that proves your identity",
                                            },
                                        },
                                    },
                                    onError: (error) => {
                                        console.error("WebSDK onError", error);
                                    },
                                }}
                                options={{ addViewportTag: false, adaptIframeHeight: true }}
                                onMessage={(type, payload) => {
                                    console.log("Sumsub message:", type, payload);

                                    if (
                                        type === "idCheck.onApplicantStatusChanged" &&
                                        payload?.reviewResult?.reviewAnswer === "GREEN"
                                    ) {

                                        console.log("Verification completed successfully");
                                        setTab("Completed")
                                        // navigate("/");
                                    } else {
                                        setShowRefreshButton(true);
                                    }
                                }}
                                onError={(data) => console.log("onError", data)}
                            />

                            {/* Refresh Button Rendered Conditionally */}
                            {/* {showRefreshButton && (
                        <button
                            onClick={() => navigate("/dashboard")}
                            style={{
                                padding: "10px 15px",
                                marginTop: "10px",
                                borderRadius: "5px",
                                backgroundColor: "#215C98",
                                color: "white",
                                cursor: "pointer",
                                border: "none",
                                position: 'absolute',
                                top: 0,
                                right: 20,
                            }}
                        >
                            Go To Dashboard
                        </button>
                    )} */}
                        </>
                    ) : (
                        <h3>Loading...</h3>
                    )}
        </div>
    );
};

export default SumsubVerification;